import { z } from 'zod'

export const bugReportTypes = [
  { value: 'bug', label: 'Bug / Error' },
  { value: 'improvement', label: 'Mejora' },
  { value: 'other', label: 'Otro' }
]

export const bugReportSchema = z.object({
  type: z.enum(['bug', 'improvement', 'other']),
  description: z.string().min(10, 'La descripción debe tener al menos 10 caracteres').max(5000, 'La descripción no puede superar los 5000 caracteres')
})

/**
 * Valida los datos para crear un reporte de bug
 * @param {Object} data - Datos a validar
 * @returns {{ success: boolean, errors: Object }}
 */
export const createBugReportValidator = (data) => {
  const result = bugReportSchema.safeParse(data)

  if (result.success) {
    return { success: true, errors: {} }
  }

  const errors = {}

  result.error.issues.forEach((err) => {
    const key = err.path && err.path.length > 0 ? err.path.join('.') : '_form'
    const message = err.message

    if (errors[key]) {
      if (Array.isArray(errors[key])) {
        errors[key].push(message)
      } else {
        errors[key] = [errors[key], message]
      }
    } else {
      errors[key] = message
    }
  })

  return { success: false, errors }
}
